export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.dashboard',
        key: 'sidebar.dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'sidebar.label',
        key: 'sidebar.label',
        route: '/delivery',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'sidebar.pending_order',
            key: 'sidebar.pending_order',
            to: '/delivery/pending'
          },
          {
            name: 'sidebar.delivery_inbound',
            key: 'sidebar.delivery_inbound',
            to: '/delivery/order/inbound'
          },
          {
            name: 'sidebar.delivery_outbound',
            key: 'sidebar.delivery_outbound',
            to: '/delivery/order/outbound'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'sidebar.marketplace',
        key: 'sidebar.marketplace',
        route: '/marketplace',
        icon: 'cil-cursor',
        items: [
          {
            name: 'sidebar.marketplace_order',
            key: 'sidebar.marketplace_order',
            to: '/marketplace/order'
          },
          {
            name: 'sidebar.marketplace_pending_accept',
            key: 'sidebar.marketplace_pending_accept',
            to: '/marketplace/order/pending-accept'
          },
          {
            name: 'sidebar.marketplace_order_shipment',
            key: 'sidebar.marketplace_order_shipment',
            to: '/marketplace/order/shipment'
          },
          
          {
            name: 'sidebar.marketplace_faq',
            key: 'sidebar.marketplace_faq',
            to: '/marketplace/faq'
          },
          {
            name: 'sidebar.contact_message',
            key: 'sidebar.contact_message',
            to: '/marketplace/contact'
          },
          {
            name: 'sidebar.marketplace_store',
            key: 'sidebar.marketplace_store',
            to: '/marketplace/store'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.marketplace_rma_product',
        key: 'sidebar.marketplace_rma_product',
        to: '/rma-product',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.shipment',
        key: 'sidebar.shipment',
        icon: 'cil-puzzle',
        to: '/delivery/shipment'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.supplier_invoice',
        key: 'sidebar.supplier_invoice',
        icon: 'cil-puzzle',
        to: '/supplier-invoice'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.supplier',
        key: 'sidebar.supplier',
        icon: 'cil-speedometer',
        to: '/supplier',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.courier',
        key: 'sidebar.courier',
        to: '/courier',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Extras']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'sidebar.tracking',
        key: 'sidebar.tracking',
        href: 'https://www.lme.com.hk/tracking-center',
        icon: { name: 'cil-layers', class: 'text-white' },
        _class: 'bg-success text-white',
        target: '_blank'
      }
    ]
  }
]